import { useMemo, useRef } from 'react';
import { getAiPromptType } from '@client/util';

interface UseProductDiscoveryProps {
  adjustedQuotes: any[];
  traditionalLTCQuotes: any[];
  isJoint: boolean;
}

export function useProductDiscovery({
  adjustedQuotes,
  traditionalLTCQuotes,
  isJoint
}: UseProductDiscoveryProps) {
  const prevProductsRef = useRef<string[]>([]);

  const productsToSearch = useMemo(() => {
    const uniqueProductNames = new Set<string>();

    adjustedQuotes.forEach((quote) => {
      if (quote.productName) {
        uniqueProductNames.add(quote.productName);
      }
    });

    traditionalLTCQuotes.forEach((quote) => {
      if (quote.productName) {
        uniqueProductNames.add(quote.productName);
      }
    });

    const newProducts = Array.from(uniqueProductNames).filter(productName => {
      const aiPromptType = getAiPromptType('', productName, isJoint);
      return aiPromptType !== null;
    });

    // Only return new array if products actually changed
    const productsChanged = newProducts.length !== prevProductsRef.current.length ||
      newProducts.some(product => !prevProductsRef.current.includes(product));

    if (productsChanged) {
      prevProductsRef.current = newProducts;
      return newProducts;
    }

    return prevProductsRef.current;
  }, [adjustedQuotes, traditionalLTCQuotes, isJoint]);

  return { productsToSearch };
}